// VNEC v9 — pages/quick-approve.js
// Fast approve cash PYC + ứng quỹ
import { supabase, getCurrentUser, approveRecord, rejectRecord } from '../lib/supabase.js';
import { formatVND } from '../lib/forms.js';
import { fmtCompact } from '../lib/dashboard.js';

let _state = { data: [], filtered: [], selected: new Set(), filter: 'all', user: null };

export function renderQuickApprove() {
  window.__pageInit = initQuickApprove;
  return `
    <div class="qa-wrap">
      <div class="page-hd">
        <h2>Duyệt nhanh PYC Tiền mặt / Ứng quỹ</h2>
        <button class="btn btn-ghost btn-sm" id="qa-refresh">⟳ Refresh</button>
      </div>
      <div class="qa-stats" id="qa-stats"></div>
      <div class="qa-batch" id="qa-batch">
        <div><b id="qa-batch-text">0 phiếu</b> <span id="qa-batch-total" class="muted"></span></div>
        <div class="qa-batch-actions">
          <button class="btn-mini approve" id="batch-approve">✓ Duyệt hàng loạt</button>
          <button class="btn-mini reject" id="batch-reject">✗ Từ chối hàng loạt</button>
          <button class="btn-mini view" id="batch-clear">Bỏ chọn</button>
        </div>
      </div>
      <div class="tabs" id="qa-tabs">
        <button class="tab active" data-filter="all">Tất cả <span class="tab-cnt" id="qc-all">0</span></button>
        <button class="tab" data-filter="pending_l1">Chờ duyệt <span class="tab-cnt" id="qc-Pending">0</span></button>
        <button class="tab" data-filter="pending_l2">Chờ duyệt L2 <span class="tab-cnt" id="qc-Approved_L1">0</span></button>
      </div>
      <div class="qa-select-all" id="qa-select-all-wrap" style="display:none">
        <input type="checkbox" id="qa-select-all">
        <label for="qa-select-all">Chọn tất cả đang hiển thị</label>
      </div>
      <div class="qa-list" id="qa-list"><div class="loading">Đang tải…</div></div>
    </div>`;
}

async function initQuickApprove() {
  _state.user = await getCurrentUser();
  document.getElementById('qa-refresh').addEventListener('click', load);
  document.getElementById('batch-approve').addEventListener('click', batchApprove);
  document.getElementById('batch-reject').addEventListener('click', batchReject);
  document.getElementById('batch-clear').addEventListener('click', clearSel);
  document.getElementById('qa-select-all').addEventListener('change', e => toggleAll(e.target.checked));
  document.querySelectorAll('#qa-tabs .tab').forEach(b => b.addEventListener('click', () => filterBy(b.dataset.filter)));
  await load();
}

async function load() {
  document.getElementById('qa-list').innerHTML = '<div class="loading">Đang tải…</div>';
  try {
    const { data, error } = await supabase.rpc('get_pyc_cash_and_ungquy_pending');
    if (error) throw error;
    // RPC returns { pyc_pending: [...] } — extract array
    let rows = [];
    if (Array.isArray(data)) {
      rows = data;
    } else if (data && Array.isArray(data.pyc_pending)) {
      rows = data.pyc_pending;
    }
    _state.data = rows;
    _state.selected.clear();
    updateStats();
    filterBy(_state.filter);
  } catch (e) {
    document.getElementById('qa-list').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function updateStats() {
  const total = _state.data.length;
  const pending = _state.data.filter(i => i.trang_thai === 'pending_l1').length;
  const l1 = _state.data.filter(i => i.trang_thai === 'pending_l2').length;
  // RPC returns so_tien (not tong_chi_ky)
  const amount = _state.data.reduce((s, i) => s + (parseFloat(i.so_tien || i.tong_chi_ky) || 0), 0);
  document.getElementById('qa-stats').innerHTML = `
    <div class="qa-st gold"><div class="qa-st-val">${total}</div><div class="qa-st-lbl">Tổng phiếu</div></div>
    <div class="qa-st"><div class="qa-st-val">${pending}</div><div class="qa-st-lbl">Chờ duyệt</div></div>
    <div class="qa-st orange"><div class="qa-st-val">${l1}</div><div class="qa-st-lbl">Chờ duyệt L2</div></div>
    <div class="qa-st green"><div class="qa-st-val money">${fmtCompact(amount)}</div><div class="qa-st-lbl">Tổng giá trị (VNĐ)</div></div>`;
  document.getElementById('qc-all').textContent = total;
  document.getElementById('qc-Pending').textContent = pending;
  document.getElementById('qc-Approved_L1').textContent = l1;
}

function filterBy(f) {
  _state.filter = f;
  document.querySelectorAll('#qa-tabs .tab').forEach(b => b.classList.toggle('active', b.dataset.filter === f));
  _state.filtered = f === 'all' ? _state.data.slice() : _state.data.filter(i => i.trang_thai === f);
  _state.selected.clear();
  renderList();
  updateBatchBar();
}

function renderList() {
  const el = document.getElementById('qa-list');
  if (!_state.filtered.length) {
    el.innerHTML = '<div class="empty"><div class="empty-icon">✓</div><div>Không có PYC cần duyệt</div></div>';
    document.getElementById('qa-select-all-wrap').style.display = 'none';
    return;
  }
  document.getElementById('qa-select-all-wrap').style.display = 'flex';
  document.getElementById('qa-select-all').checked = false;

  const uEmail = (_state.user?.email || '').toLowerCase();
  const role = _state.user?.role || 'viewer';
  const isAdmin = role === 'admin';

  let html = '';
  _state.filtered.forEach(item => {
    const isL1 = item.trang_thai === 'pending_l2';
    const sel = _state.selected.has(item.id);
    const isCreator = (item.created_by || '').toLowerCase() === uEmail;
    const isL1Same = (item.approved_l1_by || item.nguoi_duyet || '').toLowerCase() === uEmail;
    const blockedL1 = isCreator && !isAdmin;
    const blockedL2 = (isCreator || isL1Same) && !isAdmin;
    const cantL2 = role === 'approver_l1';
    const stBg = isL1 ? '<span class="bg-st l1">Duyệt L1</span>' : '<span class="bg-st pending">Chờ duyệt</span>';
    const lpBg = item.loai_pyc === 'ung_quy' ? '<span class="bg-st sub">Ứng quỹ</span>'
               : item.loai_pyc === 'tam_ung' ? '<span class="bg-st info">Tạm ứng</span>' : '';
    const apDisabled = isL1 ? (blockedL2 || cantL2) : blockedL1;
    const apLabel = isL1 ? 'Duyệt L2' : 'Duyệt';
    const apTitle = isL1 ? (cantL2 ? 'Không có quyền L2' : blockedL2 ? 'Four-eyes' : '')
                         : (blockedL1 ? 'Không thể tự duyệt' : '');

    html += `
      <div class="qa-card${sel?' selected':''}${isL1?' is-l1':''}" data-id="${item.id}">
        <div class="qa-card-head">
          <input type="checkbox" class="qa-cb" ${sel?'checked':''} data-id="${item.id}">
          <div class="qa-card-info">
            <div class="qa-card-sp">${escH(item.so_phieu)} ${stBg}${lpBg}</div>
            <div class="qa-card-meta">
              <span>HD: ${escH(item.ma_hd || 'N/A')}</span>
              <span>${escH(item.created_by || '')}</span>
              <span>${fmtDate(item.created_at)}</span>
            </div>
          </div>
          <div class="qa-card-amount">${formatVND(item.so_tien || item.tong_chi_ky)}</div>
        </div>
        <div class="qa-card-body">
          <div class="qa-card-detail">${escH(item.ky_tt || '')}${item.noi_dung ? ' — ' + escH(item.noi_dung) : ''}</div>
          <div class="qa-card-actions">
            <button class="btn-mini approve" data-act="approve" data-id="${item.id}" data-isl1="${isL1?1:0}"${apDisabled?` disabled title="${apTitle}"`:''}>${apLabel}</button>
            <button class="btn-mini reject" data-act="reject" data-id="${item.id}"${blockedL1?' disabled':''}>Từ chối</button>
          </div>
        </div>
      </div>`;
  });
  el.innerHTML = html;

  el.querySelectorAll('.qa-cb').forEach(cb => cb.addEventListener('click', e => { e.stopPropagation(); toggleOne(cb.dataset.id); }));
  el.querySelectorAll('button[data-act]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const item = _state.data.find(x => x.id === btn.dataset.id);
      if (!item) return;
      if (btn.dataset.act === 'approve') approveOne(item, btn.dataset.isl1 === '1' ? 2 : 1);
      else rejectOne(item);
    });
  });
}

function toggleOne(id) {
  if (_state.selected.has(id)) _state.selected.delete(id); else _state.selected.add(id);
  const card = document.querySelector(`.qa-card[data-id="${id}"]`);
  if (card) card.classList.toggle('selected', _state.selected.has(id));
  updateBatchBar();
}

function toggleAll(checked) {
  _state.filtered.forEach(i => { if (checked) _state.selected.add(i.id); else _state.selected.delete(i.id); });
  renderList();
  updateBatchBar();
}

function clearSel() {
  _state.selected.clear();
  document.getElementById('qa-select-all').checked = false;
  renderList();
  updateBatchBar();
}

function updateBatchBar() {
  const bar = document.getElementById('qa-batch');
  const n = _state.selected.size;
  if (n === 0) { bar.classList.remove('show'); return; }
  bar.classList.add('show');
  const total = _state.filtered.filter(i => _state.selected.has(i.id)).reduce((s,i)=>s+(parseFloat(i.tong_chi_ky)||0),0);
  document.getElementById('qa-batch-text').textContent = `${n} phiếu đã chọn`;
  document.getElementById('qa-batch-total').textContent = `(${formatVND(total)} VNĐ)`;
}

async function approveOne(item, level) {
  if (!confirm(`Duyệt L${level} phiếu ${item.so_phieu}?`)) return;
  try {
    const { error } = await supabase.rpc('approve_record', { p_table: 'pyctt', p_id: item.id, p_level: level });
    if (error) throw error;
    toast('Đã duyệt ' + item.so_phieu, 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function rejectOne(item) {
  const reason = prompt('Lý do từ chối (bắt buộc, tối thiểu 3 ký tự):');
  if (!reason || reason.trim().length < 3) return;
  try {
    await rejectRecord('pyctt', item.id, reason.trim());
    toast('Đã từ chối ' + item.so_phieu, 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function batchApprove() {
  if (_state.selected.size === 0) { toast('Chưa chọn phiếu nào', 'err'); return; }
  if (!confirm(`Duyệt ${_state.selected.size} phiếu?`)) return;
  let success = 0, failed = 0, lastErr = '';
  for (const id of _state.selected) {
    const item = _state.data.find(x => x.id === id);
    if (!item) continue;
    const level = item.trang_thai === 'pending_l2' ? 2 : 1;
    try {
      const { error } = await supabase.rpc('approve_record', { p_table: 'pyctt', p_id: id, p_level: level });
      if (error) throw error;
      success++;
    } catch (e) { failed++; lastErr = e.message; }
  }
  if (success > 0) toast(`Đã duyệt ${success}/${_state.selected.size} phiếu`, 'ok');
  if (failed > 0) toast(`${failed} phiếu lỗi — cuối: ${lastErr}`, 'err');
  load();
}

async function batchReject() {
  if (_state.selected.size === 0) { toast('Chưa chọn phiếu nào', 'err'); return; }
  const reason = prompt(`Từ chối ${_state.selected.size} phiếu. Lý do (bắt buộc, tối thiểu 3 ký tự):`);
  if (!reason || reason.trim().length < 3) return;
  let success = 0, failed = 0;
  for (const id of _state.selected) {
    try {
      await rejectRecord('pyctt', id, reason.trim());
      success++;
    } catch (e) { failed++; }
  }
  if (success > 0) toast(`Đã từ chối ${success}/${_state.selected.size} phiếu`, 'ok');
  if (failed > 0) toast(`${failed} phiếu lỗi`, 'err');
  load();
}

function escH(s) { return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function fmtDate(s) { if (!s) return ''; try { return new Date(s).toLocaleDateString('vi-VN'); } catch(e) { return s; } }
function toast(msg, type='ok') {
  const c = document.getElementById('toast-container'); if (!c) { alert(msg); return; }
  const el = document.createElement('div');
  el.className = 'toast toast-' + type;
  el.textContent = msg;
  c.appendChild(el);
  setTimeout(() => el.remove(), 3500);
}
